// eslint-disable-next-line
import { comingSoon, nowPlaying, toBeDetermined, christmasWeekend } from "../data";

const posterStyle = {
  maxWidth: "100%",
  maxHeight: "800px",
  aspectRatio: "2/3",
};

export default function ComingSoon() {
  const upcomingWeekends = [
    {
      dates: { start: "11/06/2026", end: "11/07/2026" },
      movies: [comingSoon[0], comingSoon[1]],
    },
    {
      dates: { start: "12/04/2026", end: "12/05/2026" },
      movies: [christmasWeekend[0], christmasWeekend[1]],
    }

  ];

  return (
    <section id="currentFeaturesParent" className="min-vh100 m-0">
      <div className="text-center">
        {/* Header Card */}
        <div className="d-inline-flex text-center border border-3 border-primary rounded text-light shadow-lg lg:m-5 m-3 mb-0">
          <div className="p-3" style={{ backgroundColor: "#000000" }}>
            <h1>
              <strong>Coming Soon!</strong>
            </h1>
            <p>Click or tap the movie poster below to see the IMDb entry!</p>
            <p>
              If there is no date posted, our booking has not yet been confirmed
              for that date.
            </p>
            <p>
              If there is a "To Be Determined" placeholder, our booking has not
              yet been confirmed for that movie.
            </p>
          </div>
        </div>

        {/* Movies Sections - One for each weekend */}
        <div className="text-light">
          {upcomingWeekends.map((weekend, weekendIndex) => (
            <section
              key={`weekend-${weekendIndex}`}
              className="row text-center bg-dark border-top rounded m-5"
            >
              {/* Date Header */}
              <div className="d-inline-flex justify-content-center m-5 mx-auto">
                <div
                  className="text-center border border-3 border-primary rounded shadow-lg p-3"
                  style={{ backgroundColor: "#000000" }}
                >
                  <h2>
                    Weekend of <strong>{weekend.dates.start}</strong> &{" "}
                    <strong>{weekend.dates.end}</strong>!
                  </h2>
                  <h3 className="my-3">
                    <strong>{weekend.movies[0].title}</strong> will be followed
                    by <strong>{weekend.movies[1].title}</strong>!
                  </h3>
                </div>
              </div>

              {/* Movie Cards - Only map through the 2 movies for this weekend */}
              <div className="">
                <section className="row justify-content-evenly text-center">
                  {weekend.movies.map((movie, index) => (
                    <div
                      key={`weekend-${weekendIndex}-movie-${index}`}
                      className="col-lg-5 col-md-12"
                    >
                      <div
                        className="border border-danger border-3 rounded shadow-lg p-3 my-3"
                        style={{ backgroundColor: "#000000" }}
                      >
                        <a
                          href={movie.imdb}
                          target="_blank"
                          rel="noreferrer"
                          className="text-decoration-none"
                        >
                          <h1 className="text-light pt-2">
                            <strong>{movie.title}</strong>
                          </h1>
                        </a>
                        <div className="container">
                          <a href={movie.imdb} target="_blank" rel="noreferrer">
                            <img
                              src={movie.image}
                              alt={`${movie.title} poster`}
                              className="border border-light rounded shadow-lg"
                              style={posterStyle}
                            />
                            <p className="text-light">Image source: IMDb</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </section>
              </div>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}
